import React from "react";
import "../assets/css/downloadProgress.css"; // Ensure styling is imported

const DownloadProgressModal = ({ isOpen, fileName, progress, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="download-modal-overlay">
      <div className="download-modal-card">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="btn-close position-absolute top-0 end-0 m-3 small"
          style={{ fontSize: "0.8rem" }}
        ></button>

        {/* Header */}
        <h5 className="fw-bold mb-4" style={{ fontSize: "1.1rem" }}>
          Downloading your file...
        </h5>

        {/* Content Row */}
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="d-flex align-items-center gap-3">
            <div className="download-icon-circle">
              <i className="bi bi-file-earmark-text-fill fs-5"></i>
            </div>
            <div>
              <div className="fw-bold text-dark" style={{ fontSize: "0.95rem" }}>
                {fileName || "Report.pdf"}
              </div>
              <div className="text-muted" style={{ fontSize: "0.75rem" }}>
                Preparing data...
              </div>
            </div>
          </div>
          
          {/* Brand/Robot Icon from image */}
          <div className="brand-icon-circle text-primary">
            <i className="bi bi-robot"></i> 
          </div>
        </div>

        {/* Progress Bar */}
        <div className="custom-progress-bg">
          <div
            className="custom-progress-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        {/* Percentage Text */}
        <div className="d-flex justify-content-end">
          <span
            className="fw-bold text-secondary"
            style={{ fontSize: "0.8rem" }}
          >
            {progress}% Completed
          </span>
        </div>
      </div>
    </div>
  );
};

export default DownloadProgressModal;